import React from 'react';
import PropTypes from 'prop-types';

const RewindPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M14.459 5.826L.446 15.168a1.001 1.001 0 0 0 0 1.664l14.013 9.342a1 1 0 0 0 1.555-.832V19.22l10.431 6.954A1 1 0 0 0 28 25.342V6.658a1 1 0 0 0-1.555-.832l-10.431 6.955V6.658a1 1 0 0 0-1.555-.832z"
    />
  );
};

RewindPath.propTypes = {
  fill: PropTypes.string,
};

export default RewindPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/rewind.jsx